
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SingleFarmar from "./SingleFarmar";

const FramerSection = () => {
  const [farmer, setFarmer] = useState([]);
  useEffect( () => {
    fetch('https://rocky-ravine-79485.herokuapp.com/users').then(res=>res.json()).then(data=>setFarmer(data))
   
  }, []);
  if(farmer.length>4){
    const newfarmer =farmer.slice(0,4)
    setFarmer(newfarmer)
  }

  return (
    <div className="farmer-section">
      <Container>
        <div className="farmer-title-text">
          <h5 className="text-success">Our suppliers</h5>
          <h2>Meet Our Farmers</h2>
          <Col md={{ span: 8, offset: 2 }}>
            <p>
              Growing up on a farm, in my opinion, is the best place to be
              raised." In the "In their Own Words" series, you hear directly
              from one of our farmer-owner families. We are highlight their hard
              work across all generations, to build and maintain their legacy.
            </p>
          </Col>
        </div>

        <Row className="pt-5">
          {Array.isArray(farmer)?(
            farmer.map(farmer=><Col key={farmer?._id} md={3} sm={6} className="pb-4">
            <SingleFarmar info={farmer}></SingleFarmar>
          </Col>)
          ):''}
        </Row>
      </Container>
    </div>
  );
};

export default FramerSection;
